import * as React from "react"
import Seo from "../components/seo"
import './contact-us.css'
import HeaderNav from "../components/home-page2/HeaderNav"
import Footer from "../components/home-page2/Footer"
// import HeroLeftSide from "../components/home-page2/hero-left-side"
import Tikmark from "../components/home-page2/assets/tikmark.svg";

const FreeTrial = () => {

  return (
    <div className="flex flex-col">
      <section
        className="hero-section relative pb-16 md:pb-20 lg:pb-[120px] pt-5 lg:pt-7 px-4"
        id="hero"
      >
        <HeaderNav />
        <div className="max-w-[1200px] w-full mx-auto flex flex-col lg:flex-row pt-10 lg:pt-[106px] gap-10">
          {/* LeftSide /> */}
          <div className="w-full lg:w-1/2 flex flex-col justify-center order-2 lg:order-1 mt-12">
            <h1 className="text-[40px] md:text-[70px] leading-[48px] md:leading-[84px] jost-f font-semibold text-white uppercase mb-3 md:mb-5">Start your FREE 30 day trial</h1>
            <div className="text-light1 text-sm md:text-xl font-normal mb-6 md:mb-11" >

            <div className="flex items-center justify-center border border-[#0000001A] rounded-[24px] gap-[10px] h-10 ">
                <img src={Tikmark} alt="Tikmark" loading="lazy" className="w-[14px] h-[14px]" />
                <span className="font-normal text-base flex-1">
                Ingest up to 3GB of logs, metrics, and traces per day
                </span>
              </div>
              <div className="flex items-center justify-center border border-[#0000001A] rounded-[24px] gap-[10px] h-10 "
              >
                <img src={Tikmark} alt="Tikmark" loading="lazy" className="w-[14px] h-[14px]"  />
                <span className="font-normal text-base flex-1">
                  7-day retention period
                </span>
              </div>

              <div className="flex items-center justify-center border border-[#0000001A] rounded-[24px] gap-[10px] h-10 ">
                <img src={Tikmark} alt="Tikmark" loading="lazy" className="w-[14px] h-[14px]" />
                <span className="font-normal text-base flex-1">
                  Query with OLAP-capable SQL
                </span>
              </div>

              <div className="flex items-center justify-center border border-[#0000001A] rounded-[24px] gap-[10px] h-10 ">
                <img src={Tikmark} alt="Tikmark" loading="lazy" className="w-[14px] h-[14px]" />
                <span className="font-normal text-base flex-1">
                  Query with AI in natural language
                </span>
              </div>

              
                
            </div>
          </div>

          <div className="w-full pt-[55px] lg:w-1/2 order-1 lg:order-2">



            <form
              className=" space-y-6 px-6 py-[30px] bg-gray-50 shadow-md rounded-lg mb-10"
              action="https://formspree.io/f/xnnqngrv"
              method="POST"
            >
              <label htmlFor="first-name" className="block">
                <span className="block text-sm font-medium text-gray-700">
                  First name<span className="text-red-500">*</span>
                </span>
                <input
                  type="text"
                  id="first-name"
                  name="first-name"
                  required
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
              </label>

              <label htmlFor="last-name" className="block">
                <span className="block text-sm font-medium text-gray-700">
                  Last name<span className="text-red-500">*</span>
                </span>
                <input
                  type="text"
                  id="last-name"
                  name="last-name"
                  required
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
              </label>

              {/* Email Input */}
              <label htmlFor="email" className="block">
                <span className="block text-sm font-medium text-gray-700">
                  Email <span className="text-red-500">*</span>
                </span>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  placeholder="Enter your email"
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
              </label>

              {/* Organization name */}
              <label htmlFor="company" className="block">
                <span className="block text-sm font-medium text-gray-700">
                Organization name <span className="text-red-500">*</span>
                </span>
                <input
                  type="text"
                  id="company"
                  name="company"
                  required
                  placeholder="Enter your organization name"
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
              </label>

              
              {/* Submit Button */}
              <button
                type="submit"
                className="w-full py-2 px-4 bg-indigo-600 text-white font-medium text-sm rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ">
                START
              </button>
            </form>
          </div>
        </div>
      </section>
      <Footer />

    </div>
  )
}

export const Head = () => <Seo title="Free Trial | Obics" description={undefined} children={undefined} ></Seo>

export default FreeTrial
